import { useState } from 'react';
import { useIsomorphicLayoutEffect as useLayoutEffect } from 'react-use';

import { RobotAttempt } from '../robot.types';

export function getSyntaxError(markers?: RobotAttempt['markers']): string | undefined {
    if (markers && Object.keys(markers.result).length === 1) {
        const exceptionType = markers.result[0]?.check_details.errors?.exception_type;
        if (['SyntaxError', 'IndentationError'].includes(exceptionType || '')) {
            return exceptionType;
        }
    }

    return markers?.error;
}

export function useSyntaxError(results?: RobotAttempt['markers'], attempt?: RobotAttempt['markers']) {
    const [error, setError] = useState<string>();

    useLayoutEffect(() => setError(getSyntaxError(results)), [results]);
    useLayoutEffect(() => setError(getSyntaxError(attempt)), [attempt]);

    return error;
}
